<script lang="ts">
  import { currentPoints, points, scores } from '../stores/scores';
  import { fade } from 'svelte/transition';

  export let flag: string;
  
  let addedPoints: number = -1;
  
  $: score = $scores.filter(s => s.flag === flag)[0];

  $: if ($currentPoints === 0) {
    addedPoints = -1;
  }

  const updateScores = () => {
    if (addedPoints !== -1) {
      return;
    }

    if ($currentPoints < 10) {
      const pts: number = points[$currentPoints];
      scores.update(() => [...$scores.filter(s => s.flag !== flag), {flag: score.flag, name: score.name, points: score.points + pts}]);
      currentPoints.update(() => $currentPoints + 1);
      addedPoints = pts;
    }
  };
</script>

<style>
  div {
    display: flex;
  }
  
  .name {
    margin-left: 1rem;
    max-width: 20rem;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
  }
  
  .score {
    align-items: center;
    background: rgba(74,109,163,.9);
    background: linear-gradient(140deg, rgba(74,109,163,.9) 0%, rgba(0,149,255,.9) 100%);
    color: white;
    cursor: pointer;
    justify-content: space-between;
    font-size: 1.25rem;
    padding: 0.5rem 1rem;
    transition: background 300ms linear;
  }

  p {
    margin: 0;
  }

  .points {
    font-size: 1.5rem;
    font-weight: bold;
    text-align: right;
    width: 5rem;
  }

  .position {
    font-weight: bold;
    margin-right: 1rem;
    width: 1rem;
  }

  .flag-icon {
    width: 2.5rem;
  }

  .points-given {
    background:  rgba(0, 50, 126, 0.9);
  }

  .twelve-points {
    background: bisque;
    color: black;
    box-shadow: 0 0 0.5rem 0.25rem rgba(253,247,240, 0.5);
    font-weight: bold;
  }

  .points-added {
    background-color: rgba(0,149,255,.9);
    display: grid;
    font-weight: bold;
    height: 1.6875rem;
    place-items: center;
    width: 2.5rem;
  }

  .twelve-points .points-added {
    background-color: rgb(253,247,240);
    color: black;
  }
</style>

<div class="score" class:points-given={addedPoints !== -1 && addedPoints !== 12} class:twelve-points={addedPoints === 12} on:click={updateScores}>
  <div>
    {#if addedPoints !== -1}
      <span in:fade={{duration: 300}} class="points-added">{addedPoints}</span>
    {:else}
      <span class="flag-icon flag-icon-{score.flag}"></span>
    {/if}
    <p class="name">{score.name.split(' (')[0]}</p>
  </div>
  <p class="points">{score.points}</p>
</div>
